
import './TimelineSlider.css';

interface TimelineSliderProps {
  value: number;
  onChange: (year: number) => void;
  label: string;
}

const TimelineSlider = ({ value, onChange, label }: TimelineSliderProps) => {
  const years = [2020, 2040, 2060, 2080, 2100];

  return (
    <div className="timeline-slider-container">
      <label className="timeline-slider-label">{label}</label>
      <input
        type="range"
        min="0"
        max="4"
        value={value}
        onChange={(e) => onChange(years[parseInt(e.target.value)])}
        className="timeline-slider"
      />
      <div className="timeline-slider-ticks">
        {years.map(year => (
          <span key={year}>{year}</span>
        ))}
      </div>
    </div>
  );
};

export default TimelineSlider; 